import { Card, List, ListItem, ListItemText, ListItemIcon } from "@material-ui/core";
import {
  PersonAddDisabled,
  Launch,
  AddBoxOutlined,
  EventAvailable,
  Comment
} from "@material-ui/icons";
import locale from "@bonliva-crm/locale";

type Props = {
  withNextContactDate: boolean;
  canUntag: boolean;

  onOpenProfile: (e: React.SyntheticEvent) => void;
  onCreateOpportunity: (e: React.SyntheticEvent) => void;
  onNextContactDate: (e: React.SyntheticEvent) => void;
  onUntag: (e: React.SyntheticEvent) => void;
  onEditStatusNote: (e: React.SyntheticEvent) => void;
};

export function ConsultantPipelineCardMenu(props: Props) {
  const menu = [
    {
      label: locale.openCard,
      onClick: props.onOpenProfile,
      icon: <Launch />
    },
    {
      label: locale.createPresentation,
      onClick: props.onCreateOpportunity,
      icon: <AddBoxOutlined />
    },
    props.withNextContactDate && {
      label: locale.NextContact,
      onClick: props.onNextContactDate,
      icon: <EventAvailable />
    },
    {
      label: locale.untag,
      onClick: props.onUntag,
      icon: <PersonAddDisabled />,
      disabled: !props.canUntag
    },
    {
      label: locale.editNote,
      onClick: props.onEditStatusNote,
      icon: <Comment />
    }
  ].filter(Boolean);

  return (
    <Card style={{ padding: 0, marginLeft: 8, marginRight: 8 }}>
      <List>
        {menu.map((item, i) => (
          <ListItem key={i} button onClick={item.onClick} disabled={item.disabled}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItem>
        ))}
      </List>
    </Card>
  );
}
